import React, { forwardRef, useCallback, useImperativeHandle } from 'react';
import useCallbackRef from 'hooks/useCallbackRef';
import { MoveFilesToFolder } from '../MoveFilesToFolder';
import { MoveFilesToFolderProps } from '../MoveFilesToFolder/MoveFilesToFolder.component';
import { SideDrawerRef } from 'router/subrouters/DataRoom/components/SideDrawer/SideDrawer.component';
import SideDrawer from 'router/subrouters/DataRoom/components/SideDrawer';

import './MoveDrawer.styles.scss';

const MoveDrawer: React.ForwardRefRenderFunction<
  SideDrawerRef,
  MoveFilesToFolderProps
> = (props, ref) => {
  const [drawer, drawerRef] = useCallbackRef<SideDrawerRef>(null);

  useImperativeHandle(ref, () => drawer, [drawer]);

  const closeMoveFiles = useCallback(() => {
    drawer.setOpen(false);
    props?.closeMoveFiles();
  }, [drawer, props]);

  return (
    <SideDrawer
      ref={drawerRef}
      className="move-drawer"
      closeAction={props.closeMoveFiles}
    >
      <MoveFilesToFolder
        {...props}
        isOpen={drawer?.open}
        closeMoveFiles={closeMoveFiles}
      />
    </SideDrawer>
  );
};

export default forwardRef(MoveDrawer);
